import {
    SourceWellKnownFolderType,
    Folder,
    isFolderOrSubFolderOfDistinguishedFolder,
    SHARED_FOLDERS_TREE_TYPE,
} from 'owa-folders';

export const enum MoveKind {
    Normal,
    ShadowMailbox_Copy,
    ShadowMailbox_Delete,
    SharedFolder,
}

const isOrUnderJunkOrDeleted = (folder: Folder) =>
    isFolderOrSubFolderOfDistinguishedFolder(folder, 'deleteditems') ||
    isFolderOrSubFolderOfDistinguishedFolder(folder, 'junkemail');

export default (isShadowMailbox: boolean, sourceFolder: Folder, destinationFolder: Folder) => {
    if (
        (sourceFolder && sourceFolder.treeType === SHARED_FOLDERS_TREE_TYPE) ||
        (destinationFolder && destinationFolder.treeType === SHARED_FOLDERS_TREE_TYPE)
    ) {
        return MoveKind.SharedFolder;
    } else if (!isShadowMailbox) {
        return MoveKind.Normal;
    } else if (
        sourceFolder.sourceWellKnownFolderType == SourceWellKnownFolderType.AllMail &&
        !isOrUnderJunkOrDeleted(destinationFolder)
    ) {
        return MoveKind.ShadowMailbox_Copy;
    } else if (
        !isOrUnderJunkOrDeleted(sourceFolder) &&
        destinationFolder.sourceWellKnownFolderType == SourceWellKnownFolderType.AllMail
    ) {
        return MoveKind.ShadowMailbox_Delete;
    } else {
        return MoveKind.Normal;
    }
};
